export const getFmsUrl = (fmsLanguage: string): string => {
  return `${window.config.fmsUrl}&lang=${fmsLanguage}`;
};
